import React from "react";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { COMPANY } from "@/lib/site";

export default function FinalCTA() {
  return (
    <section
      id="contatti"
      data-testid="final-cta-section"
      className="relative bg-[#0a0a0a] py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 carbon-bg opacity-40 pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-1 red-bar" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#E63946]" />
          <span className="text-xs uppercase tracking-[0.3em] font-mono text-[#E63946]">
            / 06 — Contatti
          </span>
          <div className="w-10 h-px bg-[#E63946]" />
        </div>

        <h2 className="font-heading font-black leading-[0.85] tracking-tighter text-5xl md:text-7xl lg:text-8xl mb-8 max-w-5xl mx-auto">
          Pronto a rimettere
          <br />
          in moto il tuo
          <br />
          <span className="text-[#E63946]">veicolo?</span>
        </h2>

        <p className="text-zinc-400 max-w-2xl mx-auto text-lg leading-relaxed mb-12">
          Contatta i nostri esperti oggi stesso. Troveremo il ricambio perfetto
          per le tue esigenze con la garanzia di qualità MotorieRicambi.
        </p>

        <a
          href={`tel:${COMPANY.phoneRaw}`}
          data-testid="cta-phone-big"
          className="group inline-flex flex-col items-center gap-3 mb-10"
        >
          <span className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-400 group-hover:text-[#E63946] transition-colors">
            Chiama Ora
          </span>
          <span className="font-heading font-black text-4xl md:text-6xl lg:text-7xl text-white group-hover:text-[#E63946] transition-colors tracking-tighter">
            {COMPANY.phone}
          </span>
        </a>

        <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="cta-call-btn"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-[#E63946] hover:bg-[#c81d25] text-white font-bold uppercase tracking-widest text-sm transition-all duration-300"
          >
            <Phone size={16} />
            Chiama Subito
            <ArrowRight
              size={16}
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
          <a
            href={`https://wa.me/${COMPANY.whatsappRaw}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="inline-flex items-center gap-3 px-8 py-4 border border-[#25D366] hover:bg-[#25D366] hover:text-black text-[#25D366] font-bold uppercase tracking-widest text-sm transition-all duration-300"
          >
            <MessageCircle size={16} />
            Scrivici su WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
